// resources/js/price-format.js

import AutoNumeric from 'autonumeric';

document.addEventListener("DOMContentLoaded", () => {

    function initPriceFormatter() {
        document.querySelectorAll('[data-price-format]').forEach((el) => {

            if (el.dataset.priceInitialized === "true") return;

            new AutoNumeric(el, {
                digitGroupSeparator: ',',
                decimalCharacter: '.',
                decimalPlaces: 0
            });

            el.dataset.priceInitialized = "true";
        });
    }

    initPriceFormatter();

    // For Livewire / Ajax / Dynamic DOM updates
    const observer = new MutationObserver(() => {
        initPriceFormatter();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

});